export enum EMyJio {
    "SOURCE" = "MYJIO"
  }
